import uuid from "uuid/v4";

export const viajeSchema = {
  nivel: "Nivel viajes: Solo input de un numero => 5",
  descripcion: "Descripcion",
  objetivoDesarrolloSostenible: "Objetivo Desarrollo Sostenible",
  fechaComienzo: "Fecha de Comienzo",
  etapas: [
    {
      key: uuid(),
      nombreEtapa: "Primera Etapa",
      status: "process",
      actividades: [
        {
          key: uuid(),
          tituloActividad: "",
          descripcionActividad: "",
          ordenActividad: 1,
          tipoActividad: "empty",
          linkActividad: "",
          imageSet: [],
          upload: [],
          trivia: []
        }
      ]
    },
    {
      key: uuid(),
      nombreEtapa: "Segunda Etapa",
      status: "wait",
      actividades: [
        {
          key: uuid(),
          tituloActividad: "",
          descripcionActividad: "",
          tipoActividad: "empty",
          linkActividad: "",
          imageSet: [],
          upload: [],
          trivia: []
        }
      ]
    },
    {
      key: uuid(),
      nombreEtapa: "Tercera Etapa",
      status: "wait",
      actividades: [
        {
          key: uuid(),
          tituloActividad: "",
          descripcionActividad: "",
          tipoActividad: "empty",
          upload: [],
          linkActividad: "",
          imageSet: [],
          trivia: []
        }
      ]
    },
    {
      key: uuid(),
      nombreEtapa: "Cuarta Etapa",
      status: "wait",
      actividades: [
        {
          key: uuid(),
          tituloActividad: "",
          descripcionActividad: "",
          tipoActividad: "empty",
          linkActividad: "",
          upload: [],
          imageSet: [],
          trivia: []
        }
      ]
    },
    {
      key: uuid(),
      nombreEtapa: "Quinta Etapa",
      status: "wait",
      actividades: [
        {
          key: uuid(),
          tituloActividad: "",
          descripcionActividad: "",
          tipoActividad: "empty",
          upload: [],
          imageSet: [],
          linkActividad: "",
          trivia: []
        }
      ]
    },
    {
      key: uuid(),
      nombreEtapa: "Sexta Etapa",
      status: "wait",
      actividades: [
        {
          key: uuid(),
          tituloActividad: "",
          descripcionActividad: "",
          tipoActividad: "empty",
          linkActividad: "",
          imageSet: [],
          upload: [],
          trivia: []
        }
      ]
    },
    {
      key: uuid(),
      nombreEtapa: "Septima Etapa",
      status: "wait",
      actividades: [
        {
          key: uuid(),
          tituloActividad: "",
          descripcionActividad: "",
          tipoActividad: "empty",
          imageSet: [],
          upload: [],
          linkActividad: "",
          trivia: []
        }
      ]
    },
    {
      key: uuid(),
      nombreEtapa: "Etapa octava",
      status: "wait",
      actividades: [
        {
          key: uuid(),
          tituloActividad: "",
          descripcionActividad: "",
          tipoActividad: "empty",
          imageSet: [],
          upload: [],
          linkActividad: "",
          trivia: []
        }
      ]
    }
  ]
};
